export default __webpack_public_path__ + "static/media/intermediate-wizard.24f47648.svg";